module.exports = __webpack_public_path__ + "static/img/logo-4-4.746d41d1.png";